// Actions
const ADD_COMMENT_TO_REFERRAL_SUCCESS =
  "hermes/activity/ADD_COMMENT_TO_REFERRAL_SUCCESS";
const CLEAR_ADDED_COMMENTS = "hermes/activity/CLEAR_ADDED_COMMENTS";
const SAVE_VARIABLES = "hermes/activity/SAVE_VARIABLES";
const PERSIST_VARIABLES = "hermes/activity/PERSIST_VARIABLES";
const CLEAR_VARIABLES = "hermes/activity/CLEAR_VARIABLES";

const initialState = {
  userList: [],
  allList: [],
  addedComments: [],
  savedSearchVariables: undefined,
  useSaved: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_COMMENT_TO_REFERRAL_SUCCESS:
      return {
        ...state,
        addedComments: [...state.addedComments, action.comment],
      };
    case CLEAR_ADDED_COMMENTS:
      return {
        ...state,
        addedComments: [],
      };
    case SAVE_VARIABLES:
      return {
        ...state,
        savedSearchVariables: action.variables,
      };
    case PERSIST_VARIABLES:
      return {
        ...state,
        useSaved: true,
      };
    case CLEAR_VARIABLES:
      return {
        ...state,
        savedSearchVariables: undefined,
        useSaved: false,
      };
    default:
      return state;
  }
}

export function addCommentToReferralSuccess(comment) {
  return {
    type: ADD_COMMENT_TO_REFERRAL_SUCCESS,
    comment,
  };
}

// Action Creators
export function saveVariables(variables) {
  return {
    type: SAVE_VARIABLES,
    variables,
  };
}

export function persistVariables() {
  return {
    type: PERSIST_VARIABLES,
  };
}

export function clearVariables() {
  return {
    type: CLEAR_VARIABLES,
  };
}

export function clearAddedComments() {
  return {
    type: CLEAR_ADDED_COMMENTS,
  };
}
